import {
    Dropdown,
    makeStyles,
    Option,
    OptionOnSelectData,
    SelectionEvents,
    Text,
    Radio,
    Checkbox,
    CheckboxOnChangeData
} from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { ChevronRightRegular } from "@fluentui/react-icons";
import "../../fonticons/icons.css"

export type LocationDropDownObject = {
    label: string;
    subLabel?: string;
};

export enum LocationDropdownTypeEnum {
    Country = "Country",
    City = "City",
    Site = "Site",
    Building = "Building",
    Floor = "Floor",
    Zone = "Zone"
}

export const LocationDropdownIconMap: Record<LocationDropdownTypeEnum, string> = {
    Country: "icon-level-Country",
    City: "icon-level-City",
    Site: "icon-level-Site",
    Building: "icon-level-Building",
    Floor: "icon-level-Floor",
    Zone: "icon-level-Zone"
};

type LocationSelectorDropdownProps = {
    theme: string;
    value: string;
    placeHolder: string;
    type: LocationDropdownTypeEnum;
    dropDownList: LocationDropDownObject[];

    isFilterEnabled: boolean;
    isFilterChecked: boolean;
    onFilterChange: (level: LocationDropdownTypeEnum, checked: boolean) => void;

    onSelect: (value: string, type: LocationDropdownTypeEnum) => void;
};

const useStyles = makeStyles({
    root: {
        height: "23px",
        gap: "5px",
        borderRadius: "4px",
        border: "0px"
    },
    listbox: {
        minWidth: "max-content",
        whiteSpace: "nowrap"
    },
    chevron: {
        transition: "transform 0.2s ease"
    }
});

const LocationSelectorDropdown = ({
    theme,
    value,
    placeHolder,
    type,
    dropDownList,
    isFilterEnabled,
    isFilterChecked,
    onFilterChange,
    onSelect
}: LocationSelectorDropdownProps) => {

    const styles = useStyles();
    const [open, setOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState<number>(-1);

    useEffect(() => {

    }, [isFilterChecked]);

    useEffect(() => {
        const index = dropDownList.findIndex(
            item => item.label === value
        );
        setSelectedIndex(index);
    }, [value, dropDownList]);

    const onOptionsSelect = (
        event: SelectionEvents,
        data: OptionOnSelectData
    ) => {
        setOpen(false);
        const index = Number(data.optionValue);
        setSelectedIndex(index);
        onSelect(data.optionText ?? "", type);
    };

    const onCheckChange = (
        ev: React.ChangeEvent<HTMLInputElement>,
        data: CheckboxOnChangeData
    ) => {
        console.log("Filter event Dropdown: ", ev);
        console.log("Filter Change Dropdown: ", data.checked);
        onFilterChange(type, Boolean(data.checked))
    };

    return (
        <Dropdown
            button={<span>{value || placeHolder}</span>}
            size="small"
            className={styles.root}
            open={open}
            onOpenChange={(_, data) => setOpen(data.open)}
            onOptionSelect={onOptionsSelect}
            listbox={{ className: styles.listbox }}
            style={{ border: value === "" ? (theme === "dark" ? "1px dashed #525252" : "1px dashed #EAEFF5") : (theme === "dark" ? "1px solid #525252" : "1px solid #EAEFF5"), opacity: value === "" ? 0.7 : 1 }}
            expandIcon={value !== "" ? ({
                children: (
                    <ChevronRightRegular
                        className={styles.chevron}
                        style={{ transform: open ? "rotate(90deg)" : "" }}
                    />
                ),
            }) : null}
        >
            {isFilterEnabled && (
                <div
                    onClick={(e) => e.stopPropagation()}
                >
                    <Checkbox
                        label="Apply Location Filter"
                        checked={isFilterChecked ?? false}
                        onChange={onCheckChange}
                    />
                </div>
            )}

            {dropDownList.map((object, index) => (
                <Option
                    key={object.label}
                    value={index.toString()}
                    text={object.label}
                    checkIcon={null}
                >
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 8 }}>
                        <Radio checked={selectedIndex === index} />
                        <span
                            className={LocationDropdownIconMap[type]}
                            style={{ fontSize: 20 }}
                        />
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Text size={300}>{object.label}</Text>
                            {object.subLabel && (
                                <Text size={100}>{object.subLabel}</Text>
                            )}
                        </div>
                    </div>
                </Option>
            ))}
        </Dropdown>
    );
};

export default LocationSelectorDropdown;
